import { Project } from "../../../types";
import { useProjects } from "./useProjects";
import { useEffect, useState } from "react";
import { getProjectsApi } from "../../../api/resources.api";

export function useProjectsLoadMore() {
  const [page, setPage] = useState(1);
  const [projects, setProjects] = useState<Project[]>([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const { data, isLoading } = useProjects(page);

  useEffect(() => {
    if (!data?.data) return;
    setProjects((prev) => {
      const map = new Map<number, Project>();
      [...prev, ...data.data].forEach((item) => map.set(item.id, item));
      return Array.from(map.values());
    });
  }, [data]);

  const loadMore = async () => {
    if (loadingMore || !data?.meta?.has_more_pages) return;

    try {
      setLoadingMore(true);

      const nextPage = page + 1;
      const secondPage = page + 2;

      const [res1, res2] = await Promise.all([
        getProjectsApi({ page: nextPage }),
        getProjectsApi({ page: secondPage }),
      ]);

      setProjects((prev) => {
        const map = new Map<number, Project>();

        [...prev, ...(res1.data ?? []), ...(res2.data ?? [])].forEach((item) =>
          map.set(item.id, item),
        );

        return Array.from(map.values());
      });

      setPage(secondPage);
    } finally {
      setLoadingMore(false);
    }
  };

  return {
    projects,
    loadMore,
    loadingMore,
    hasMore: data?.meta?.has_more_pages ?? false,
    isLoading,
  };
}
